import { createFileRoute, redirect } from "@tanstack/react-router";
import { ensureElementVisible } from "@/lib/route-guards";

// Skrót z menu Synchronizacja do SQL Konsoli (F4, D77/D79). Sam moduł żyje pod
// /konfiguracja/sql-konsola i po wejściu startuje na Target; aptekę wybiera się
// pickerem „Baza”. Element bez grantów = tylko super_admin, ta sama publiczność co
// tryb apteki konsoli.
export const Route = createFileRoute("/_auth/synchronizacja/konsola-sql")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.synchronizacja-apteki.konsola-sql",
			location.pathname,
		);
		throw redirect({ to: "/konfiguracja/sql-konsola" });
	},
});
